// The conversion door for gated/anonymous CTAs. The package ships the
// production default; it reads no env (it is shell-agnostic). A shell that
// needs a different target (e.g. staging, or the env-driven free SPA) injects
// it via TrackerProvider's `signupUrl` prop; consumers read it through
// `useSignupUrl()`, which falls back to this default.
export const VWAM_SIGNUP_URL = 'https://app.vwam.ai/register'

// Tracker-origin signups should return to the tracker on their first platform
// visit. Apply this centrally so every CTA and shell-injected signup URL gets
// the same fixed, internal return path.
export function appendReturnTo(url: string, returnTo: string): string {
  try {
    const parsed = new URL(url)

    parsed.searchParams.set('returnTo', returnTo)
    return parsed.toString()
  } catch {
    return url
  }
}
